import { DeclarationForm } from '../components/DeclarationForm/DeclarationForm';

// Inbounds ▸ Incoming Declarations ▸ Validate — see DeclarationForm for the shared UI.
export const ValidateDeclarationPage = () => <DeclarationForm mode="validate" />;
